import { ETenderLookupService } from "@nt-portal/tcm-sdk";
import { BaseClientService } from "../../base-client.service";


export class ClientETenderLookupService extends BaseClientService {

    private _service: ETenderLookupService;


    constructor() {
        super();
        this._service = new ETenderLookupService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async provinces() {
        return this._service.getProvinces(this.token);
    }

    public async categories() {
        return this._service.getCategories(this.token);
    }

    public async tenderTypes() {
        return this._service.getTenderTypes(this.token);
    }

    public async tenderSubTypes() {
        return this._service.getTenderSubTypes(this.token);
    }

    public async organOfStates() {
        return this._service.getOrganOfState(this.token);
    }

}